import { render } from "./GenericChannel.vue?vue&type=template&id=0cc92f5e"
import script from "./GenericChannel.vue?vue&type=script&lang=js"
export * from "./GenericChannel.vue?vue&type=script&lang=js"

import exportComponent from "/home/app/rails/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__